import React from 'react'
import ReceivedAppointment from '../Components/ReceivedAppointment/ReceivedAppointment'

const ReceivedAppointmentView = () => {
  return (
    <div>
        <ReceivedAppointment />
    </div>
  )
}

export default ReceivedAppointmentView